module.exports = __webpack_public_path__ + "static/profile-user-c1e15af82ad0df61c8bde1478d9d00a6.png";